import { ILoaiGioHoc } from "../../model/respone/category/ILoaiGioHoc";
import { apiClient } from "../apiClient";

export const LOAI_GIO_HOC_API = "loai-gio-hoc";
export const loaiGioHocApi = {
  SelectAll: () => apiClient.get(`${LOAI_GIO_HOC_API}`),
  Insert: (payload: ILoaiGioHoc) => apiClient.post(`${LOAI_GIO_HOC_API}`, payload),
  Update: (payload: ILoaiGioHoc) => apiClient.put(`${LOAI_GIO_HOC_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${LOAI_GIO_HOC_API}/${id}`),
};
